import Headroom from 'headroom.js';
import { inView } from 'global/inview.src';

/*-----------------------------------------------------------------------------------*/
/* Main
/*-----------------------------------------------------------------------------------*/
// mobile check
window.mobilecheck = function () {
    let check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4),
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

$(document).ready(() => {
    /* ------------------------------------*\
        accordion
    \*------------------------------------*/
    const accordions = document.querySelectorAll('.accordion');
    let details;
    [].forEach.call(accordions, (accordion) => {
        details = accordion.querySelectorAll('details');
        [].forEach.call(details, (elem) => {
            const inner = elem.querySelector('.inner');
            inner.style.display = 'none';
            const summary = elem.querySelector('summary');
            summary.addEventListener('click', (e) => {
                e.preventDefault();
                if (elem.getAttribute('open')) {
                    elem.removeAttribute('open');
                    inner.style.display = 'none';
                } else {
                    elem.setAttribute('open', 'true');
                    inner.style.display = 'block';
                }
            });
        });
    });

    // animate
    inView({
        elems: document.querySelectorAll('.in-view'),
        onVisible(elem) {
            elem.classList.add('visible');
            elem.classList.add('animation-running');
        },
        tolerance: 0.25,
    });

    if (typeof Headroom !== 'undefined') {
        const headerElement = document.querySelector('.rheader');
        if (headerElement !== null) {
            const headroom = new Headroom(headerElement, {
                tolerance: 10,
                classes: {
                    pinned: 'rheader--pinned',
                    unpinned: 'rheader--unpinned',
                    top: 'rheader--top',
                    notTop: 'rheader--not-top',
                    initial: 'rheader',
                },
            });
            headroom.init();
        }
    }

    const bodyRect = document.body.getBoundingClientRect();
    const elemRect = document.getElementById('single-social').getBoundingClientRect();
    const offset = elemRect.top - bodyRect.top;

    // social popup
    if (!window.mobilecheck()) {
        Array.prototype.forEach.call(document.querySelectorAll('.popup'), (a) => {
            a.addEventListener('click', function (e) {
                const width = 575;
                const height = 400;
                const left = (window.innerWidth - width) / 2;
                const top = (window.innerHeight - height) / 2;
                const url = this.href;
                const opts = `${'status=1' + ',width='}${width},height=${height},top=${top},left=${left}`;

                e.stopPropagation();
                e.preventDefault();

                window.open(a.getAttribute('href'), '', opts);
            });
        });
    }

    // close top info about new data
    $('.close').on('click', () => {
        $('#new-data').remove();
    });

    // sort table
    let thIndex = 0;
    let curThIndex = null;

    $('table:not([data-status="disabled"])').each(function () {
        const table = $(this);
        $(this)
            .find('thead tr th')
            .on('click', function () {
                // switch
                if ($(this).find('.sort').is('.up')) {
                    table.find('.sort').removeClass('up down');
                    $(this).find('.sort').addClass('down');
                } else {
                    table.find('.sort').removeClass('up down');
                    $(this).find('.sort').addClass('up');
                }

                // sort table
                thIndex = $(this).index();
                curThIndex = thIndex;
                let sorting = [];

                [].forEach.call(table.get(0).querySelectorAll('tbody tr:not(.total)'), (el) => {
                    sorting.push(el);
                });

                if (this.getAttribute('data-type') === 'proc') {
                    sorting = sorting.sort((a, b) => {
                        const aPerc = $(a).children('td').eq(curThIndex).html().slice(0, -1).replace(',', '.') * 1;
                        const bPerc = $(b).children('td').eq(curThIndex).html().slice(0, -1).replace(',', '.') * 1;

                        if (aPerc < bPerc) {
                            return -1;
                        }
                        if (aPerc > bPerc) {
                            return 1;
                        }
                        return 0;
                    });
                } else if (this.getAttribute('data-type') === 'range') {
                    sorting = sorting.sort((a, b) => {
                        const aPerc = $(a).children('td').eq(curThIndex).data('value') * 1;
                        const bPerc = $(b).children('td').eq(curThIndex).data('value') * 1;

                        if (aPerc < bPerc) {
                            return -1;
                        }
                        if (aPerc > bPerc) {
                            return 1;
                        }
                        return 0;
                    });
                } else if (this.getAttribute('data-type') === 'num') {
                    sorting = sorting.sort((a, b) => {
                        const aPerc = $(a).children('td').eq(curThIndex).text().replace(',', '.').replace('+', '').replace(/\s/g, '') * 1;
                        const bPerc = $(b).children('td').eq(curThIndex).text().replace(',', '.').replace('+', '').replace(/\s/g, '') * 1;

                        if (aPerc < bPerc) {
                            return -1;
                        }
                        if (aPerc > bPerc) {
                            return 1;
                        }
                        return 0;
                    });
                } else {
                    sorting = sorting.sort((a, b) => {
                        const aPerc = $(a).children('td').eq(curThIndex).text();
                        const bPerc = $(b).children('td').eq(curThIndex).text();

                        if (aPerc < bPerc) {
                            return -1;
                        }
                        if (aPerc > bPerc) {
                            return 1;
                        }
                        return 0;
                    });
                }
                if ($(this).find('.sort').is('.down')) {
                    sorting = sorting.reverse();
                }
                table.find('tbody').empty();
                sorting.forEach((el) => {
                    table.find('tbody').append(el);
                });
            });
    });

    // go to anchor
    $('*[data-anchor="scroll"]').on('click', function (e) {
        $(document).off('scroll');

        const target = this.hash;
        const $target = $(target);

        const scroll = $target.offset().top;
        $('html,body').animate({ scrollTop: scroll }, 'slow');
    });

    // copy anchor
    function copyToClipboard(element) {
        const $temp = $('<input>');
        $('body').append($temp);
        $temp.val(`${allUrl}#${$(element).data('setanchor')}`).select();
        document.execCommand('copy');
        $temp.remove();
    }
    $('*[data-setanchor]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboard($(this));
        $(this).addClass('copied');
        setTimeout(() => {
            $('*[data-setanchor]').removeClass('copied');
        }, 1000);
    });

    // select anchor on scroll
    $(window)
        .scroll(() => {
            const scrollDistance = $(window).scrollTop();
            // Assign active class to nav links while scolling
            $('[data-section="select-anchor"]').each(function (i) {
                if ($(this).position().top - 100 <= scrollDistance) {
                    $('#main-nav li.active').removeClass('active');
                    $('#main-nav li').eq(i).addClass('active');
                }
            });
        })
        .scroll();

    // subject-line cycle
    const SlOpenRate = Array();
    var SlThroughRate = Array();
    var SlThroughRate = Array();
    const SlXAxes = Array();
    const SlMessages = Array();
    var value;

    // get subject-line data
    $('#subject-line tbody tr').each(function (i) {
        SlXAxes[i] = Array();
        $(this)
            .children('td:eq(0)')
            .each(function () {
                value = $(this).text();
                SlXAxes[i] = value;
            });
        SlOpenRate[i] = Array();
        $(this)
            .children('td:eq(1)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                SlOpenRate[i] = value;
            });
        SlThroughRate[i] = Array();
        $(this)
            .children('td:eq(2)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                SlThroughRate[i] = value;
            });
        SlMessages[i] = Array();
        $(this)
            .children('td:eq(3)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                SlMessages[i] = value;
            });
    });

    var ctx = document.getElementById('subject-line-chart');
    const SlChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
            labels: SlXAxes,
            datasets: [
                {
                    label: 'Open rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: SlOpenRate,
                    spanGaps: false,
                },
                {
                    label: 'Click-through rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255,0.4)',
                    borderColor: 'rgba(0, 186, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: SlThroughRate,
                    spanGaps: false,
                },
                {
                    label: '% of messages',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(121, 62, 255,0.4)',
                    borderColor: 'rgba(121, 62, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(121, 62, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: SlMessages,
                    spanGaps: false,
                },
            ],
        },
        options: {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            min: 0,
                            fixedStepSize: 2.5,
                        },
                    },
                ],
            },
        },
    });

    // chart for day cycle
    const HodOpenRate = Array();
    const HodThroughRate = Array();
    const HodClickOpenRate = Array();
    const HodOfMessages = Array();
    const HodXAxes = Array();
    const HodUnsubscribe = Array();
    const HodComplaint = Array();
    const HodBounce = Array();
    var value;

    $('#hour-of-day tbody tr').each(function (i) {
        HodXAxes[i] = Array();
        $(this)
            .children('td:eq(0)')
            .each(function () {
                value = $(this).text();
                HodXAxes[i] = value;
            });
        HodOpenRate[i] = Array();
        $(this)
            .children('td:eq(1)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodOpenRate[i] = value;
            });
        HodThroughRate[i] = Array();
        $(this)
            .children('td:eq(2)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodThroughRate[i] = value;
            });
        HodClickOpenRate[i] = Array();
        $(this)
            .children('td:eq(3)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodClickOpenRate[i] = value;
            });
        HodUnsubscribe[i] = Array();
        $(this)
            .children('td:eq(4)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodUnsubscribe[i] = value;
            });
        HodComplaint[i] = Array();
        $(this)
            .children('td:eq(5)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodComplaint[i] = value;
            });
        HodBounce[i] = Array();
        $(this)
            .children('td:eq(6)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodBounce[i] = value;
            });
        HodOfMessages[i] = Array();
        $(this)
            .children('td:eq(7)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HodOfMessages[i] = value;
            });
    });

    var ctx = document.getElementById('hour-of-day-chart');
    const hodChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: HodXAxes,
            datasets: [
                {
                    label: 'Open rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.5)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(75,192,192,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodOpenRate,
                    spanGaps: false,
                },
                {
                    label: 'Click-through rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255, 0.5)',
                    borderColor: 'rgba(0, 186, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodThroughRate,
                    spanGaps: false,
                },
                {
                    label: 'Click-to-open rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 73, 164, 0.5)',
                    borderColor: 'rgba(0, 73, 164, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 73, 164, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 73, 164, 1)',
                    pointHoverBorderColor: 'rgba(0, 73, 164, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodClickOpenRate,
                    spanGaps: false,
                },
                {
                    label: 'Unsubscribe rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(121, 62, 255, 0.5)',
                    borderColor: 'rgba(121, 62, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(121, 62, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodUnsubscribe,
                    spanGaps: false,
                },
                {
                    label: 'Complaint rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255,0.0.5)',
                    borderColor: 'rgba(0, 186, 255,0.1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255,0.1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255,0.1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255,0.1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodComplaint,
                    spanGaps: false,
                },
                {
                    label: 'Bounce rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(211, 57, 142, 0.5)',
                    borderColor: 'rgba(211, 57, 142, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(211, 57, 142, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(211, 57, 142, 1)',
                    pointHoverBorderColor: 'rgba(211, 57, 142, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodBounce,
                    spanGaps: false,
                },
                {
                    label: '% of messages',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(231,207,222,0.5)',
                    borderColor: 'rgba(231,207,222,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(231,207,222,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(231,207,222,1)',
                    pointHoverBorderColor: 'rgba(231,207,222,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HodOfMessages,
                    spanGaps: false,
                },
            ],
        },
        options: {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            min: 0,
                            fixedStepSize: 2.5,
                            callback(value) {
                                return `${value}%`;
                            },
                        },
                    },
                ],
            },
        },
    });
    // chart for week cycle
    const HowOpenRate = Array();
    const HowThroughRate = Array();
    const HowClickOpenRate = Array();
    const HowOfMessages = Array();
    const HowXAxes = Array();
    const HowUnsubscribe = Array();
    const HowComplaint = Array();
    const HowBounce = Array();
    var value;

    $('#hour-of-week tbody tr').each(function (i) {
        HowXAxes[i] = Array();
        $(this)
            .children('td:eq(0)')
            .each(function () {
                value = $(this).text();
                HowXAxes[i] = value;
            });
        HowOpenRate[i] = Array();
        $(this)
            .children('td:eq(1)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowOpenRate[i] = value;
            });
        HowThroughRate[i] = Array();
        $(this)
            .children('td:eq(2)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowThroughRate[i] = value;
            });
        HowClickOpenRate[i] = Array();
        $(this)
            .children('td:eq(3)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowClickOpenRate[i] = value;
            });
        HowUnsubscribe[i] = Array();
        $(this)
            .children('td:eq(4)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowUnsubscribe[i] = value;
            });
        HowComplaint[i] = Array();
        $(this)
            .children('td:eq(5)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowComplaint[i] = value;
            });
        HowBounce[i] = Array();
        $(this)
            .children('td:eq(6)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowBounce[i] = value;
            });
        HowOfMessages[i] = Array();
        $(this)
            .children('td:eq(7)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                HowOfMessages[i] = value;
            });
    });

    var ctx = document.getElementById('hour-of-week-chart');
    const howChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: HowXAxes,
            datasets: [
                {
                    label: 'Open rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.5)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(75,192,192,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowOpenRate,
                    spanGaps: false,
                },
                {
                    label: 'Click-through rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255, 0.5)',
                    borderColor: 'rgba(0, 186, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowThroughRate,
                    spanGaps: false,
                },
                {
                    label: 'Click-to-open rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 73, 164, 0.5)',
                    borderColor: 'rgba(0, 73, 164, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 73, 164, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 73, 164, 1)',
                    pointHoverBorderColor: 'rgba(0, 73, 164, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowClickOpenRate,
                    spanGaps: false,
                },
                {
                    label: 'Unsubscribe rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(121, 62, 255, 0.5)',
                    borderColor: 'rgba(121, 62, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(121, 62, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderColor: 'rgba(121, 62, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowUnsubscribe,
                    spanGaps: false,
                },
                {
                    label: 'Complaint rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255,0.0.5)',
                    borderColor: 'rgba(0, 186, 255,0.1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255,0.1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255,0.1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255,0.1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowComplaint,
                    spanGaps: false,
                },
                {
                    label: 'Bounce rate',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(211, 57, 142, 0.5)',
                    borderColor: 'rgba(211, 57, 142, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(211, 57, 142, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(211, 57, 142, 1)',
                    pointHoverBorderColor: 'rgba(211, 57, 142, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowBounce,
                    spanGaps: false,
                },
                {
                    label: '% of messages',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(231,207,222,0.5)',
                    borderColor: 'rgba(231,207,222,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(231,207,222,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(231,207,222,1)',
                    pointHoverBorderColor: 'rgba(231,207,222,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: HowOfMessages,
                    spanGaps: false,
                },
            ],
        },
        options: {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            min: 0,
                            fixedStepSize: 2.5,
                            callback(value) {
                                return `${value}%`;
                            },
                        },
                    },
                ],
            },
        },
    });

    // chart for email address length
    const PcSubscribers = Array();
    const PcYAxes = Array();
    var value;

    $('#address-length tbody tr').each(function (i) {
        PcYAxes[i] = Array();
        $(this)
            .children('td:eq(0)')
            .each(function () {
                value = $(this).text();
                PcYAxes[i] = value;
            });
        PcSubscribers[i] = Array();
        $(this)
            .children('td:eq(1)')
            .each(function () {
                value = $(this).text();
                value = value.replace('%', '');
                PcSubscribers[i] = value;
            });
    });

    var ctx = document.getElementById('address-length-chart');
    const pcChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: PcYAxes,
            datasets: [
                {
                    label: '% subscribers',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0, 186, 255,0.4)',
                    borderColor: 'rgba(0, 186, 255, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0, 186, 255, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderColor: 'rgba(0, 186, 255, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: PcSubscribers,
                    spanGaps: false,
                },
            ],
        },
        options: {
            scales: {
                xAxes: [
                    {
                        ticks: {
                            min: 0,
                            fixedStepSize: 2.5,
                        },
                    },
                ],
            },
        },
    });
});
